import gb from "./gb.json";
import rs from "./rs.json";
import si from "./si.json";

export default { gb, rs, si };
